export default {
    computed: {
        VUETIFY_BREAKPOINT() {
            return this.$vuetify.breakpoint;
        }
    }
};